module.exports = __webpack_public_path__ + "static/media/background-signup.5baef010.png";